import { BookOpen, Image as ImageIcon, Link2, Pencil } from "lucide-react"
import type { ComponentType } from "react"

import type { ReferenceKind, ReferenceStatus } from "@/types"

export const KIND_ICON: Record<ReferenceKind, ComponentType<{ className?: string }>> = {
  file: BookOpen,
  image: ImageIcon,
  text: Pencil,
  url: Link2,
}

// Same vocabulary as the material status dots (statusVisuals.tsx): indigo
// pulses while something is in flight; one colour per meaning.
export const STATUS_DOT: Record<ReferenceStatus, string> = {
  pending: "bg-border-strong",
  processing: "bg-accent animate-pulse",
  ready: "bg-success",
  failed: "bg-danger",
}

const MIME_BY_EXTENSION: Record<string, string> = {
  pdf: "application/pdf",
  docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  txt: "text/plain",
  md: "text/markdown",
  markdown: "text/markdown",
}

/** Browsers leave `File.type` empty for .md and some .txt; the server
 *  decides by the declared type, so the file is re-wrapped with the one its
 *  extension implies before it is sent. */
export function withDeclaredMime(file: File): File {
  if (file.type) return file
  const extension = file.name.toLowerCase().split(".").pop() ?? ""
  const mime = MIME_BY_EXTENSION[extension]
  return mime ? new File([file], file.name, { type: mime, lastModified: file.lastModified }) : file
}

export function isPdf(file: File | null): boolean {
  return !!file && (file.type === "application/pdf" || file.name.toLowerCase().endsWith(".pdf"))
}
